import BaseModel from '@/models/BaseModel'
import Recipe from '@/models/Recipe'

export default class Section extends BaseModel {
  default () {
    return {
      name: String,
      recipes: [Recipe]
    }
  }

  getDefaultMethods () {
    return {
      fetch: 'GET'
    }
  }

  routes () {
    // TODO routes of Balance Model
    return {
      fetch: `${this.API_BASE}/v1/menu`
    }
  }
}
